import React from 'react';
import classnames from 'classnames';
import placeholder from 'assets/img/image-placeholder.png';
import classes from './gallery.scss';
export const Gallery = ({
  images,
  showPlaceholders
}) => {
  const isInIFrame = window.self !== window.top;
  if ((!images || !images.length) && !isInIFrame && !showPlaceholders) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.mobGap
    });
  }
  if ((!images || !images.length) && isInIFrame && showPlaceholders) {
    images = [placeholder, placeholder, placeholder];
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.root, classes[`len${images.length}`])
  }, images.map((imgSrc, index) => /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper,
    key: index
  }, /*#__PURE__*/React.createElement("img", {
    src: imgSrc
  }))));
};